import { render } from "./AlertsStatus.vue?vue&type=template&id=cd15cfda"
import script from "./AlertsStatus.vue?vue&type=script&lang=js"
export * from "./AlertsStatus.vue?vue&type=script&lang=js"

import "./AlertsStatus.vue?vue&type=style&index=0&id=cd15cfda&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__